export default function modal(state = {}, action) {
  switch (action.type) {
    case 'SET_MODAL':
      return {...state, modal: {content: action.payload, unmountOnClick: action.unmountOnClick, closable: action.closable, onClose: action.onClose}};
    default:
      return state;
  }
}
